module.exports = __webpack_public_path__ + "static/media/mode21.ce05c558.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode21.gif
// module id = 1342
// module chunks = 110